var UserRequiredPageController = require("app/UserRequiredPage/PageController"),
    RouteHandler               = require("app/core/RouteHandler"),
    ResolveLanguage            = require("app/core/middleware/ResolveLanguage"),
    kind                       = require("enyo/kind");

module.exports = [{

    /**
     * User Required Page
     *
     * @type {RegExp}
     */
    pattern: /^\/([a-z]{2})\/user-required$/,

    /**
     * @type {app.core.RouteHandler}
     */
    Handler: kind({

        /**
         * @private
         */
        kind: RouteHandler,

        /**
         * @private
         */
        middleware: [ResolveLanguage],

        /**
         * Handler for the route
         *
         * @param  {app.core.App}  app         The application core
         * @param  {string}        pathname    The matched pathname
         * @param  {Object}        params      The parameters extracted from the
         *                                     pathname
         * @param  {string}        search      The current search string
         * @param  {boolean}       skipCache   The cached data should be ignored
         * @public
         */
        execute: function(app, pathname, params, search, skipCache) {
            var language = app.$.i18nService.get("language");

            app.$.header.set("showBackButton", true);

            app.activatePage(UserRequiredPageController, {
                language:     language,
                mediaType:    null,
                redirectPath: null,
                skipCache:    skipCache
            }, true);

            app.$.analyticsService.sendPageView({
                language: language
            });

            app.deactivateMediaDetails();

            app.$.mediaPlayerManager.deactivateMediaPlayer();

            this.finish();
        }
    })
}, {

    /**
     * User Required Page + Media Type
     *
     * @type {RegExp}
     */
    pattern: /^\/([a-z]{2})\/user-required\/(album-track|audio|book|episode|issue|photo|podcast-episode|video)$/,

    /**
     * @type {app.core.RouteHandler}
     */
    Handler: kind({

        /**
         * @private
         */
        kind: RouteHandler,

        /**
         * @private
         */
        middleware: [ResolveLanguage],

        /**
         * Handler for the route
         *
         * @param  {app.core.App}  app         The application core
         * @param  {string}        pathname    The matched pathname
         * @param  {Object}        params      The parameters extracted from the
         *                                     pathname
         * @param  {string}        search      The current search string
         * @param  {boolean}       skipCache   The cached data should be ignored
         * @public
         */
        execute: function(app, pathname, params, search, skipCache) {
            var language = app.$.i18nService.get("language");

            params = {
                mediaType: params[1]
            };

            app.$.header.set("showBackButton", true);

            app.activatePage(UserRequiredPageController, {
                language:     language,
                mediaType:    params.mediaType,
                redirectPath: null,
                skipCache:    skipCache
            }, true);


            app.$.analyticsService.sendPageView({
                language:  language,
                mediaType: params.mediaType
            });

            app.deactivateMediaDetails();

            app.$.mediaPlayerManager.deactivateMediaPlayer();

            this.finish();
        }
    })
}, {

    /**
     * User Required Page + Media Type + Redirect Path
     *
     * @type {RegExp}
     */
    pattern: /^\/([a-z]{2})\/user-required\/(album-track|audio|book|episode|issue|photo|podcast-episode|video)\/(.*)$/,

    /**
     * @type {app.core.RouteHandler}
     */
    Handler: kind({

        /**
         * @private
         */
        kind: RouteHandler,

        /**
         * @private
         */
        middleware: [ResolveLanguage],

        /**
         * Handler for the route
         *
         * @param  {app.core.App}  app         The application core
         * @param  {string}        pathname    The matched pathname
         * @param  {Object}        params      The parameters extracted from the
         *                                     pathname
         * @param  {string}        search      The current search string
         * @param  {boolean}       skipCache   The cached data should be ignored
         * @public
         */
        execute: function(app, pathname, params, search, skipCache) {
            var language = app.$.i18nService.get("language");

            params = {
                mediaType:    params[1],
                redirectPath: decodeURIComponent(params[2])
            };

            app.$.header.set("showBackButton", true);

            app.activatePage(UserRequiredPageController, {
                language:     language,
                mediaType:    params.mediaType.replaceAll("-", "_"),
                redirectPath: params.redirectPath,
                skipCache:    skipCache
            }, true);

            app.$.analyticsService.sendPageView({
                language:  language,
                mediaType: params.mediaType,
                context:   params.redirectPath
            });

            app.deactivateMediaDetails();

            app.$.mediaPlayerManager.deactivateMediaPlayer();

            this.finish();
        }
    })
}, {

    /**
     * User Required Page + Redirect Path
     *
     * @type {RegExp}
     */
    pattern: /^\/([a-z]{2})\/user-required\/(.*)$/,

    /**
     * @type {app.core.RouteHandler}
     */
    Handler: kind({

        /**
         * @private
         */
        kind: RouteHandler,

        /**
         * @private
         */
        middleware: [ResolveLanguage],

        /**
         * Handler for the route
         *
         * @param  {app.core.App}  app         The application core
         * @param  {string}        pathname    The matched pathname
         * @param  {Object}        params      The parameters extracted from the
         *                                     pathname
         * @param  {string}        search      The current search string
         * @param  {boolean}       skipCache   The cached data should be ignored
         * @public
         */
        execute: function(app, pathname, params, search, skipCache) {
            var language = app.$.i18nService.get("language");

            params = {
                redirectPath: decodeURIComponent(params[1])
            };

            app.$.header.set("showBackButton", true);

            app.activatePage(UserRequiredPageController, {
                language:     language,
                mediaType:    null,
                redirectPath: params.redirectPath,
                skipCache:    skipCache
            }, true);

            app.$.analyticsService.sendPageView({
                language: language,
                context:  params.redirectPath
            });

            app.deactivateMediaDetails();

            app.$.mediaPlayerManager.deactivateMediaPlayer();

            this.finish();
        }
    })
}];
